import React from 'react';
import { Button, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

import { testId } from 'pricing/utilities/test/dataTestId';
import { FieldFileUploaderContainer } from '../FieldFileUpload.styles';

function FieldFileUploader() {
  return (
    <FieldFileUploaderContainer>
      <label>Contract Preview</label>
      <p>(.pdf, .jpg, .png files accepted)</p>
      <Upload
        multiple={false}
        showUploadList={false}
        beforeUpload={() => false}
        data-testid={testId.fieldFileUploadInput}
        accept="application/pdf, image/jpeg, image/jpg, image/png"
      >
        <Button icon={<UploadOutlined />} data-testid={testId.fieldFileUploadButton}>
          Click to upload
        </Button>
      </Upload>
    </FieldFileUploaderContainer>
  );
}

export default FieldFileUploader;
